import {
  PERSONAL_POSSESSIONS_D2C,
  UNSPECIFIED_PERSONAL_POSSESSIONS_D2C,
} from "@/constants/possessions-options";

import { VALUABLES_D2C } from "@/constants/valuable-options";

export const belongings = {
  namespaced: true,
  state: {
    d2cValuables: VALUABLES_D2C,
    d2cPersonalPossessions: PERSONAL_POSSESSIONS_D2C,
    d2cUnspecifiedPersonalPossessions: UNSPECIFIED_PERSONAL_POSSESSIONS_D2C,
  },
  actions: {
    setValuables({ state }, payload) {
      state.d2cValuables = payload;
    },
    setPersonalPossessions({ state }, payload) {
      state.d2cPersonalPossessions = payload;
    },
    setUnspecifiedPersonalPossessions({ state }, payload) {
      state.d2cUnspecifiedPersonalPossessions = payload;
    },
  },
  getters: {
    getValuables(state) {
      return state.d2cValuables;
    },
    getPersonalPossessions(state) {
      return state.d2cPersonalPossessions;
    },
    getUnspecifiedPersonalPossessions(state) {
      return state.d2cUnspecifiedPersonalPossessions;
    },
  },
  mutations: {},
};
